const ORGANIZATION_SCHEMA =
  //every page
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://kingiftcard.com/#organization',
    name: 'King gift',
    url: 'https://kingiftcard.com/',
    logo: {
      '@type': 'ImageObject',
      url: 'https://kingiftcard.com/assets/images/kingift-logo.svg',
    },
    email: 'support@kingiftcard.com',
    sameAs: [
      'https://facebook.com/kingiftcard',
      'https://x.com/kingiftcard',
      'https://instagram.com/king_giftcard',
      'https://kingiftcard.com/',
      'https://t.me/kingiftcard',
    ],
  };

const WEBSITE_SCHEMA =
  //home page
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://kingiftcard.com',
    name: 'King Gift',
    description:
      'Kingift offers a wide selection of gift cards that can be purchased securely using cryptocurrencies like USDT and Binance.',
    publisher: {
      '@type': 'Organization',
      name: 'King Gift',
      logo: 'https://kingiftcard.com/assets/images/kingift-logo.svg',
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://kingiftcard.com/search/{search_term_string}/all',
      'query-input': 'required name=search_term_string',
    },
    sameAs: [
      'https://facebook.com/kingiftcard',
      'https://x.com/kingiftcard',
      'https://instagram.com/king_giftcard',
    ],
  };
const LOCAL_BUSINESS_SCHEMA =
  //contact-us page and about page
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://kingiftcard.com/#localbusiness',
    name: 'King gift',
    image: 'https://kingiftcard.com/assets/images/kingift-logo.svg',
    url: 'https://kingiftcard.com/',
    email: 'support@kingiftcard.com',
    description:
      'King gift is a global platform for buying gift cards with cryptocurrency, offering fast delivery and a secure shopping experience.',
    address: {
      '@type': 'PostalAddress',
      streetAddress:
        'AI-Wataniya General Insurance Company Building, Port Said Street, Office No. 11-902',
      addressLocality: 'Dubai',
      postalCode: '00971',
      addressCountry: 'AE',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 25.2048493,
      longitude: 55.2707828,
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Sunday',
      ],
      opens: '09:00',
      closes: '18:00',
    },
    sameAs: [
      'https://facebook.com/kingiftcard',
      'https://x.com/kingiftcard',
      'https://instagram.com/king_giftcard',
      'https://kingiftcard.com/',
    ],
    parentOrganization: {
      '@id': 'https://kingiftcard.com/#organization',
    },
  };

export const ScriptNames = {
  website: 'website-schema',
  local: 'local-schema',
  org: 'organization-schema',
} as const;

export const scriptRegistry: Record<string, any> = {
  [ScriptNames.website]: WEBSITE_SCHEMA,
  [ScriptNames.local]: LOCAL_BUSINESS_SCHEMA,
  [ScriptNames.org]: ORGANIZATION_SCHEMA,
};
